module.exports = __webpack_public_path__ + "img/chapter-6.4674009d.jpg";